import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCompanyInformation } from '../../api/fetch-company-information';

export const fetchCompanyInformationThunk = createAsyncThunk(
    'fetchCompanyInformation',
    async () => fetchCompanyInformation(),
);
